import { useFormikContext } from 'formik';
import { debounce as _debounce, isEqual } from 'lodash';
import { useEffect, useCallback } from 'react';

import { usePrevious } from '@hivebrite/react-hooks';

const usePersistForm = (
  name,
  { debounce = 300, serialize = JSON.stringify, unserialize = JSON.parse } = {},
) => {
  const { values, setValues } = useFormikContext();

  const prevFormikState = usePrevious(values);

  const persist = useCallback(
    _debounce((state) => {
      window.sessionStorage.setItem(name, serialize(state));
    }, debounce),
    [],
  );

  useEffect(() => {
    if (isEqual(prevFormikState, values)) {
      return;
    }

    persist(values);
  }, [values]);

  useEffect(() => {
    const maybeState = window.sessionStorage.getItem(name);

    if (!maybeState) {
      return;
    }

    setValues(unserialize(maybeState));
  }, []);
};

export default usePersistForm;
